export default __webpack_public_path__ + "static/media/leadership.229de8d7.png";